// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file settings/v1/shipping_rate_definition_type.proto (package settings.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file settings/v1/shipping_rate_definition_type.proto.
 */
export const file_settings_v1_shipping_rate_definition_type: GenFile =
    /*@__PURE__*/
    fileDesc(
        'Ci9zZXR0aW5ncy92MS9zaGlwcGluZ19yYXRlX2RlZmluaXRpb25fdHlwZS5wcm90bxILc2V0dGluZ3MudjEq1QEKGlNoaXBwaW5nUmF0ZURlZmluaXRpb25UeXBlEi0KKVNISVBQSU5HX1JBVEVfREVGSU5JVElPTl9UWVBFX1VOU1BFQ0lGSUVEEAASJgoiU0hJUFBJTkdfUkFURV9ERUZJTklUSU9OX1RZUEVfRkxBVBABEi4KKlNISVBQSU5HX1JBVEVfREVGSU5JVElPTl9UWVBFX09SREVSX0FNT1VOVBACEjAKLFNISVBQSU5HX1JBVEVfREVGSU5JVElPTl9UWVBFX1BBQ0tBR0VfV0VJR0hUEANChQEKD2NvbS5zZXR0aW5ncy52MUIfU2hpcHBpbmdSYXRlRGVmaW5pdGlvblR5cGVQcm90b1ABWgQuL3BiogIDU1hYqgILU2V0dGluZ3MuVjHKAgtTZXR0aW5nc1xWMeICF1NldHRpbmdzXFYxXEdQQk1ldGFkYXRh6gIMU2V0dGluZ3M6OlYxYgZwcm90bzM'
    );

/**
 * ShippingRateDefinitionType is how a shipping rate definition prices an order:
 * one flat price, a price per order amount band, or a price per package weight
 * band. It mirrors the option definition types of the Shopify market delivery
 * API.
 *
 * @generated from enum settings.v1.ShippingRateDefinitionType
 */
export enum ShippingRateDefinitionType {
    /**
     * @generated from enum value: SHIPPING_RATE_DEFINITION_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,

    /**
     * @generated from enum value: SHIPPING_RATE_DEFINITION_TYPE_FLAT = 1;
     */
    FLAT = 1,

    /**
     * @generated from enum value: SHIPPING_RATE_DEFINITION_TYPE_ORDER_AMOUNT = 2;
     */
    ORDER_AMOUNT = 2,

    /**
     * @generated from enum value: SHIPPING_RATE_DEFINITION_TYPE_PACKAGE_WEIGHT = 3;
     */
    PACKAGE_WEIGHT = 3,
}

/**
 * Describes the enum settings.v1.ShippingRateDefinitionType.
 */
export const ShippingRateDefinitionTypeSchema: GenEnum<ShippingRateDefinitionType> =
    /*@__PURE__*/
    enumDesc(file_settings_v1_shipping_rate_definition_type, 0);
